import {
    Button,
    Card,
    Checkbox,
    Col,
    DatePicker,
    Form,
    Input,
    notification,
    Row,
    Select,
} from "antd";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { issuePriorities } from "../../services/util";
import "./Table.css";

const { Option } = Select;
function TicketForm() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [form] = Form.useForm();
    const [submitLoading, setSubmitLoading] = useState(false);
    const { loggedIn } = useContext(SettingContext);
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
            return null;
        }
    }, [loggedIn]);

    // const {
    //     status: ownerStatus,
    //     data: hubspotOwnerData,
    //     refetch: getOwners,
    // } = useQuery("hubspot-owners", async () => {
    //     return await HTTP("/dashboard/getHubspotOwners", { staff_id });
    // });

    const {
        status: hotelAffectedOptionStatus,
        data: hotelAffectedOptionRes,
        refetch: getHotelsAffectedOptions,
    } = useQuery(
        "affectedHotels",
        async () => {
            return await HTTP("/dashboard/getJiraHotelsAffected", { staff_id });
        },
        { enabled: false },
    );

    const {
        status: hotelStatus,
        data: hotelData,
        refetch: getHotels,
    } = useQuery(
        "hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "all",
            });
        },
        { enabled: false },
    );

    // const {
    //     status: stageStatus,
    //     data: stageData,
    //     refetch: getStages,
    // } = useQuery(
    //     "hubspot-stage",
    //     async () => {
    //         return await HTTP("/dashboard/getHubspotStages", { staff_id });
    //     },
    //     { enabled: false },
    // );

    const {
        status: componentStatus,
        data: componentsData,
        refetch: getComponents,
    } = useQuery(
        "hubspot-components",
        async () => {
            return await HTTP("/dashboard/getJiraComponents", { staff_id });
        },
        { enabled: false },
    );

    const {
        status: jiraAssigneeStatus,
        data: jiraAssigneeData,
        refetch: getJiraAssignee,
    } = useQuery(
        "jira-users",
        async () => {
            return await HTTP("/dashboard/getJiraUsers", {
                staff_id,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getHotels();
        // getOwners();
        // getStages();
        getComponents();
        getJiraAssignee();
        getHotelsAffectedOptions();
    }, []);

    async function handleSubmit(values) {
        // if (!values.jira_ticket && !values.hubspot_ticket) {
        //     return notification["warning"]({
        //         message:
        //             "Please select ticket type for creation(i.e. Jira/Hubspot).",
        //     });
        // }
        setSubmitLoading(true);
        values.incident_time = moment(values.incident_time).format(
            "YYYY/MM/DD HH:MM",
        );

        const formData = {
            staff_id,
            hubspot_ticket: false,
            jira_ticket: true,
            ...values,
        };
        const { success, data, message } = await HTTP(
            "/dashboard/createHubspotTicket",
            formData,
        );
        if (success === 0) {
            notification["error"]({
                message: message,
            });
        } else {
            if (data[0].key && data[0].id && data[0].self) {
                api.open({
                    message: message,
                    description: (
                        <p>
                            You can view it at &nbsp;
                            <a
                                href={`https://astics.atlassian.net/browse/${data[0].key}`}
                            >
                                {data[0].key}
                            </a>
                            .
                        </p>
                    ),
                });
            } else {
                notification["info"]({
                    message: message,
                });
            }
        }
        setSubmitLoading(false);
        form.resetFields();
    }

    return (
        <Row
            className="site-card-border-less-wrapper"
            style={{ display: "flex", justifyContent: "center" }}
        >
            <Col span="16">
                <Card title="Create Ticket">
                    <Form
                        form={form}
                        onFinish={handleSubmit}
                        initialValues={{
                            hubspot_ticket: false,
                            jira_ticket: false,
                        }}
                    >
                        <Form.Item
                            name="subject"
                            label="Subject"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Subject..!",
                                },
                            ]}
                        >
                            <Input id="subject" placeholder="Subject" />
                        </Form.Item>
                        <Form.Item
                            name="content"
                            label="Content"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Content..!",
                                },
                            ]}
                        >
                            <Input id="content" placeholder="Content" />
                        </Form.Item>
                        <Form.Item
                            label="Hotel Name"
                            name="hotel_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Hotel!",
                                },
                            ]}
                            valuePropName="defaultValue"
                        >
                            <Select
                                id="hotel_id"
                                showSearch
                                filterOption={(input, option) =>
                                    option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                {hotelStatus === "success" &&
                                hotelData?.data.length > 0
                                    ? hotelData.data.map((h) => (
                                          <Option
                                              key={h.hotel_id}
                                              value={h.hotel_id}
                                          >
                                              {`${h.hotel_id} - ${h.hotel_name} - ${h.city}`}
                                          </Option>
                                      ))
                                    : ""}
                            </Select>
                        </Form.Item>
                        {/* <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                                prevValues.jira_ticket !==
                                currentValues.jira_ticket
                            }
                        >
                            <Form.Item
                                label="Create Hubspot Ticket"
                                name="hubspot_ticket"
                                valuePropName="checked"
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (
                                                !value &&
                                                !getFieldValue("jira_ticket")
                                            ) {
                                                return Promise.reject(
                                                    "Please Select Any Platform for which you want to create ticket.",
                                                );
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Checkbox id="hubspot_ticket" />
                            </Form.Item>
                        </Form.Item> */}
                        {/* <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                                prevValues.hubspot_ticket !==
                                currentValues.hubspot_ticket
                            }
                        >
                            {({ getFieldValue }) =>
                                getFieldValue("hubspot_ticket") === true && (
                                    <>
                                        <Form.Item
                                            label="HubSpot PipeLine Stage"
                                            name="hs_pipeline_stage"
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Please Select Stage!",
                                                },
                                            ]}
                                            valuePropName="defaultValue"
                                        >
                                            <Select
                                                id="hs_pipeline_stage"
                                                loading={
                                                    stageData?.data.length === 0
                                                }
                                            >
                                                {stageStatus === "success" &&
                                                stageData?.data.length > 0
                                                    ? stageData.data.map(
                                                          (s) => (
                                                              <Option
                                                                  key={
                                                                      s.stage_id
                                                                  }
                                                                  value={
                                                                      s.stage_id
                                                                  }
                                                              >
                                                                  {s.label}
                                                              </Option>
                                                          ),
                                                      )
                                                    : ""}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label="HubSpot Owner"
                                            name="hubspot_owner_id"
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Please Select HubSpot Owner!",
                                                },
                                            ]}
                                            valuePropName="defaultValue"
                                        >
                                            <Select
                                                id="hubspot_owner_id"
                                                loading={
                                                    hubspotOwnerData?.data
                                                        .length === 0
                                                }
                                            >
                                                {ownerStatus === "success" &&
                                                hubspotOwnerData?.data.length >
                                                    0
                                                    ? hubspotOwnerData.data.map(
                                                          (s) => (
                                                              <Option
                                                                  key={
                                                                      s.owner_id
                                                                  }
                                                                  value={
                                                                      s.owner_id
                                                                  }
                                                              >
                                                                  {s.first_name}
                                                              </Option>
                                                          ),
                                                      )
                                                    : ""}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label="HubSpot Ticket Priority"
                                            name="hs_ticket_priority"
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Please Select HubSpot Ticket Priority!",
                                                },
                                            ]}
                                            valuePropName="defaultValue"
                                        >
                                            <Select id="hs_ticket_priority">
                                                {["HIGH", "MEDIUM", "LOW"].map(
                                                    (e) => (
                                                        <Option
                                                            key={e}
                                                            value={e}
                                                        >
                                                            {e}
                                                        </Option>
                                                    ),
                                                )}
                                            </Select>
                                        </Form.Item>
                                    </>
                                )
                            }
                        </Form.Item> */}
                        {/* <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                                prevValues.jira_ticket !==
                                currentValues.jira_ticket
                            }
                        >
                            <Form.Item
                                label="Create Jira Ticket"
                                name="jira_ticket"
                                valuePropName="checked"
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (
                                                !value &&
                                                !getFieldValue("hubspot_ticket")
                                            ) {
                                                return Promise.reject(
                                                    "Please Select Any Platform for which you want to create ticket.",
                                                );
                                            }
                                            return Promise.resolve();
                                        },
                                    }),
                                ]}
                            >
                                <Checkbox id="jira_ticket" />
                            </Form.Item>
                        </Form.Item> */}
                        {/* <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                                prevValues.jira_ticket !==
                                currentValues.jira_ticket
                            }
                        >
                            {({ getFieldValue }) =>
                                getFieldValue("jira_ticket") === true && ( */}
                        <>
                            <Form.Item
                                label="Component"
                                name="component_name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select Component!",
                                    },
                                ]}
                                valuePropName="defaultValue"
                            >
                                <Select
                                    id="component_name"
                                    loading={componentsData?.data.length === 0}
                                >
                                    {componentStatus === "success" &&
                                    componentsData?.data.length > 0
                                        ? componentsData.data.map((s) => (
                                              <Option
                                                  key={s.component_name}
                                                  value={s.component_name}
                                              >
                                                  {s.component_name}
                                              </Option>
                                          ))
                                        : ""}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Assignee"
                                name="assignee_id"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select Assignee!",
                                    },
                                ]}
                                valuePropName="defaultValue"
                            >
                                <Select
                                    id="assignee_id"
                                    showSearch="true"
                                    loading={
                                        jiraAssigneeData?.data.length === 0
                                    }
                                    filterOption={(input, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {jiraAssigneeStatus === "success" &&
                                    jiraAssigneeData?.data.length > 0
                                        ? jiraAssigneeData.data.map((u) => (
                                              <Option
                                                  key={u.display_name}
                                                  value={u.account_id}
                                              >
                                                  {u.display_name}
                                              </Option>
                                          ))
                                        : ""}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Affected Hotel"
                                name="hotel_affected"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            "Please Select Affected Hotel!",
                                    },
                                ]}
                                valuePropName="defaultValue"
                            >
                                <Select
                                    id="hotel_affected"
                                    showSearch
                                    loading={
                                        hotelAffectedOptionRes?.data.length ===
                                        0
                                    }
                                    filterOption={(input, option) =>
                                        option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {hotelAffectedOptionStatus === "success" &&
                                        hotelAffectedOptionRes?.data.length >
                                            0 &&
                                        hotelAffectedOptionRes.data.map((h) => (
                                            <Option
                                                key={h.hotel_affected}
                                                value={h.hotel_affected}
                                            >
                                                {h.hotel_affected}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Priority"
                                name="priority"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select Priority!",
                                    },
                                ]}
                            >
                                <Select>
                                    {issuePriorities.map((p) => (
                                        <Option key={p} value={p}>
                                            {p}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Incident Date-Time"
                                name="incident_time"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select Date-Time!",
                                    },
                                ]}
                            >
                                <DatePicker
                                    allowClear={false}
                                    showTime
                                    format="MM/DD/YYYY hh:mm"
                                    disabledDate={(current) =>
                                        current &&
                                        current > moment().endOf("day")
                                    }
                                />
                            </Form.Item>
                        </>
                        {/* )
                             }
                         </Form.Item> */}
                        <Form.Item
                            wrapperCol={{
                                offset: 8,
                                span: 16,
                            }}
                        >
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={submitLoading}
                            >
                                Create
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
            {contextHolder}
        </Row>
    );
}

export { TicketForm };
